import type { PropsWithChildren } from 'react';
import { createContext, useContext, useMemo } from 'react';

import { useCheckout } from '@jane/shared-ecomm/providers';
import { useHeadlessApp } from '@jane/shared/providers';

interface HeadlessKioskContextValue {
  isHeadlessKioskMode: boolean;
}

const HeadlessKioskContext = createContext<HeadlessKioskContextValue | null>(
  null
);

export const HeadlessKioskProvider = ({ children }: PropsWithChildren) => {
  const {
    appInfo: { isEmbeddedMode },
  } = useCheckout();
  const { options } = useHeadlessApp();

  const isHeadlessKioskMode = isEmbeddedMode && options?.kiosk === true;

  const value = useMemo(
    () => ({
      isHeadlessKioskMode,
    }),
    [isHeadlessKioskMode]
  );

  return (
    <HeadlessKioskContext.Provider value={value}>
      {children}
    </HeadlessKioskContext.Provider>
  );
};

export const useHeadlessKiosk = () => {
  const context = useContext(HeadlessKioskContext);

  if (!context) {
    // Return default values when not wrapped in provider (for non-kiosk flows)
    return {
      isHeadlessKioskMode: false,
    };
  }

  return context;
};
